import { Libraries, LoadScript } from '@react-google-maps/api';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { NavigationProvider } from '../../context/NavigationContext';
import { BreadcrumbsProvider } from '../../context/BreadcrumbsContext';
import NonAdminAppRoutes from './NonAdminAppRoutes';

const GOOGLE_MAPS_LIBRARIES: Libraries = ['places'];

export {
  CheckLoginComponent,
  CheckLoginComponentWithKey,
  CheckLoginComponentWithKeyAndLayout,
} from './CheckLoginComponent';

export default function App() {
  const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;

  return (
    <LoadScript googleMapsApiKey={googleMapsKey} libraries={GOOGLE_MAPS_LIBRARIES}>
      <BreadcrumbsProvider>
        <Router>
          <NavigationProvider>
            <NonAdminAppRoutes />
          </NavigationProvider>
        </Router>
      </BreadcrumbsProvider>
    </LoadScript>
  );
}
